import React, { useState, useEffect } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { deleteProduct } from '../http/productAPI';

function forceModalCleanup() {
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
}

const DeleteProductModal = ({ show, onHide, product, onDeleted }) => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Сброс состояния при закрытии модального окна
    useEffect(() => {
        if (!show) {
            setError('');
            setLoading(false);
        }
    }, [show]);

    useEffect(() => {
        return () => {
            forceModalCleanup();
        };
    }, []);

    const handleConfirm = async () => {
        if (!product) return;
        setLoading(true);
        setError('');
        try {
            await deleteProduct(product.id);
            if (onDeleted) {
                onDeleted();
            }
            onHide();
            forceModalCleanup();
        } catch (e) {
            setError(e.response?.data?.message || 'Ошибка при удалении товара');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered unmountOnExit={true} backdrop="static" keyboard={false} onExited={forceModalCleanup}>
            <Modal.Header closeButton>
                <Modal.Title>Удаление товара</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                Вы уверены, что хотите удалить товар "{product?.name}"?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    Отмена
                </Button>
                <Button variant="danger" onClick={handleConfirm} disabled={loading}>
                    {loading ? 'Удаление...' : 'Удалить'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteProductModal; 